module.exports = require("log");


//////////////////
// WEBPACK FOOTER
// external "log"
// module id = 11
// module chunks = 0